<script setup lang="ts">
import type {HTMLAttributes} from 'vue'
import type {ToastRootProps} from 'reka-ui'
import {reactiveOmit} from '@vueuse/core'
import {ToastRoot} from 'reka-ui'
import {useForwardProps} from 'reka-ui'
import {cn} from '@/lib/utils'

const props = defineProps<ToastRootProps & {class?: HTMLAttributes['class']; variant?: 'default' | 'destructive'}>()
const forwardedProps = useForwardProps(reactiveOmit(props, 'class', 'variant'))
</script>

<template>
  <ToastRoot
    v-bind="forwardedProps"
    :class="
      cn(
        'group pointer-events-auto relative flex w-full items-start justify-between gap-4 overflow-hidden rounded-md border bg-background p-6 pr-8 text-foreground shadow-lg transition-all data-[state=closed]:animate-out data-[state=closed]:fade-out-80 data-[state=open]:animate-in data-[state=open]:slide-in-from-top-full sm:max-w-sm',
        props.variant === 'destructive' && 'border-destructive/50 text-destructive dark:border-destructive',
        props.class
      )
    ">
    <slot />
  </ToastRoot>
</template>
